<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle20')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle20') }}</h1>
    <p>{{ $t('artText20-1') }}</p>
    <p>{{ $t('artText20-2') }}</p>
    <p>{{ $t('artText20-3') }}</p>
    <p>{{ $t('artText20-4') }}</p>
    <img
      :src="`${staticUrl}/images/blog/DreamFlat_A_Perfect_Room_Planner.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText20-5') }}</p>
    <p>{{ $t('artText20-6') }}</p>
    <p>{{ $t('artText20-7') }}</p>
    <p>{{ $t('artText20-8') }}</p>
    <p>{{ $t('artText20-9') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle20')}`,
  ogTitle: `${t('artSeoTitle20')}`,
  description: `${t('artSeoDesc20')}`,
  ogDescription: `${t('artSeoDesc20')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
